import React, { PropsWithChildren } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { ColorSystemDefinition } from "@ancon/wildcat-ui/shared";

import colorSeeds from "../../seeds/colors.json";
import aoColorSeeds from "../../seeds/ao-colors.json";
import { useLocation } from "react-router-dom";
import AppRoutes from "../../constants/routes";

type ThemeFormProps = PropsWithChildren<{}>;

export type ThemeFormValuesType = ColorSystemDefinition & { isWL: boolean };

export default function ThemeForm({ children }: ThemeFormProps) {
  const { pathname } = useLocation();
  const isWL = pathname === AppRoutes.OrderAppWL;

  const form = useForm<ThemeFormValuesType>({
    defaultValues: {
      ...(isWL ? colorSeeds : aoColorSeeds),
      isWL,
    },
  });

  return <FormProvider {...form}>{children}</FormProvider>;
}
